const {
  evaluateSource
} = require('../lib/evaluateSource');
const stripUndefined = obj => Object.fromEntries(
// eslint-disable-next-line no-unused-vars
Object.entries(obj).filter(([_k, v]) => v !== undefined));

/**
  * @function evalute - evaluate writeCurrentLocationBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const targetContentPath = await evaluateSource(source.targetContentPath, content, parentContentPath, transientContext, nativeFunctions);
  if (targetContentPath === undefined) {
    return;
  }
  const querySource = {
    type: 'currentLocationBehavior',
    includeHighAccuracyFields: true
  };
  const location = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
  if (location === undefined || location === null) {
    return;
  }
  const logContentPath = await evaluateSource(source.logContentPath, content, parentContentPath, transientContext, nativeFunctions);
  let displayValue;
  let breadcrumbs;
  const fields = await evaluateSource(source.fields, content, parentContentPath, transientContext, nativeFunctions);
  if (fields !== undefined && Array.isArray(fields)) {
    Object.keys(location).forEach(key => {
      if (!fields.includes(key)) {
        delete location[key];
      }
    });
  }
  if (logContentPath !== undefined) {
    const displayValues = [];
    const displayMap = {
      latitude: `Latitude to ${location.latitude}`,
      longitude: `Longitude to ${location.longitude}`,
      rawElevation: `Raw elevation to ${location.rawElevation} m`,
      poleAdjustedElevation: `Pole-adjusted elevation to ${location.poleAdjustedElevation} m`,
      verticalAccuracy: `Vertical accuracy to ${location.verticalAccuracy} m`,
      horizontalAccuracy: `Horizontal accuracy to ${location.horizontalAccuracy} m`,
      desiredMinimumHorizontalAccuracy: `Desired minimum horizontal accuracy to ${location.desiredMinimumHorizontalAccuracy} m`,
      desiredMinimumVerticalAccuracy: `Desired minimum vertical accuracy to ${location.desiredMinimumVerticalAccuracy} m`,
      hDop: `Horizontal Dillution of Precision to ${location.hDop}`,
      vDop: `Vertical Dillution of Precision to ${location.vDop}`,
      pDop: `Position (3D) Dillution of Precision to ${location.pDop}`,
      timestamp: `Capture date/time to ${location.timestamp}`,
      gpsQuality: `GPS quality to ${location.gpsQuality}`,
      coordinateReference: `Coordinate reference model to ${location.coordinateReference}`,
      epoch: `Epoch of the coordinate reference model to ${location.epoch}`,
      numberSatellitesUsed: `Number of satellites used to ${location.numberSatellitesUsed}`,
      numberSatellitesInView: `Number of satellites in view to ${location.numberSatellitesInView}`,
      coordinateSource: `Capture device to ${location.coordinateSource}`
    };
    Object.keys(displayMap).forEach(key => {
      if (location[key] !== undefined) {
        displayValues.push(displayMap[key]);
      }
    });
    displayValue = displayValues.join(', ');
    breadcrumbs = await evaluateSource(source.breadcrumbs, content, parentContentPath, transientContext, nativeFunctions);
  }
  const writeSource = {
    type: 'writeContentBehavior',
    targetContentPath,
    source: location,
    logContentPath,
    displayValue,
    breadcrumbs
  };
  await evaluateSource(stripUndefined(writeSource), content, parentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};